import { Card } from "../../Components/ui/card";
import { PageLayout } from "../../Components/PageLayout";
import { useGetInstance } from "../../Hooks/use-get";
import { useMutate } from "../../Hooks/use-mutate";
import { useParams } from "react-router-dom";
import { Spinner } from "../../Components/LoadingAnimations/LoadingAnimations";
import { Form } from "../../Components/ui/form/form";
import { Input } from "../../Components/ui/form/input/input";
import { Select, Option } from "../../Components/ui/form";
import { useState, useEffect } from "react";
import { Button } from "../../Components/ui/button";
import { useNavigate } from "react-router-dom";

type TrailerAsset = {
  id: number;
  unit: string;
  license_plate: string;
  location?: { loc_name?: string | null } | null;
  is_active: boolean;
};

const options: Option[] = [
  {
    optionLabel: "active",
    optionValue: "true",
  },
  {
    optionLabel: "inactive",
    optionValue: "false",
  },
];

type TrailerAssetFormData = {
  unit: string;
  license_plate: string;
  is_active: boolean;
};

const TrailerAssetRoute = () => {
  const params = useParams<{ id: string }>();
  const result = useGetInstance<TrailerAsset>(
    "/assets/trailer-assets/" + params.id,
  );

  const submitResult = useMutate<TrailerAssetFormData>(
    "/assets/trailer-assets/" + params.id + "/",
    "PATCH",
  );

  const [unit, setUnit] = useState(result.data?.unit || "");
  const [licensePlate, setLicensePlate] = useState(
    result.data?.license_plate || "",
  );
  const [status, setStatus] = useState(
    result.data?.is_active ? "true" : "false",
  );

  useEffect(() => {
    if (result.data) {
      setUnit(result.data.unit);
      setLicensePlate(result.data.license_plate);
      setStatus(result.data.is_active ? "true" : "false");
    }
  }, [result.data]);

  const handleSubmit = async (e: React.SubmitEvent) => {
    e.preventDefault();
    try {
      await submitResult.mutate({
        unit,
        license_plate: licensePlate,
        is_active: status === "true",
      });
    } catch (error) {
      console.error("Failed to update trailer asset", error);
    }
  };
  const navigate = useNavigate();

  return (
    <>
      {result.isLoading ? (
        <Spinner />
      ) : (
        <PageLayout title={unit} header="">
            <Button labelKey="back" variant="secondary" onClick={() => navigate("/trailer-assets")} />
          <Card title={unit} size="md">
            <Form onSubmit={handleSubmit} isLoading={submitResult.isLoading}>
              <Input label="unit" value={unit} onChange={(e) => setUnit(e.target.value)} />
              <Input
                label="licensePlate"
                value={licensePlate}
                onChange={(e) => setLicensePlate(e.target.value)}
              />
              <Select
                label="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                options={options}
              />
            </Form>
          </Card>
        </PageLayout>
      )}
    </>
  );
};

export default TrailerAssetRoute;
